<template>
  <c-modal-form
    :id="$getConst('SERVICE_ORDER_MODAL_ID')"
    :loading="loading"
    :submit-btn-enabled="canSubmit"
    submit-btn-text="Заказать"
    :error="error"
    fields-required
    title="Заказать услугу"
    @submit="submit()"
  >
    <form>
      <c-input
        v-model="phone"
        form-group
        :input-mask="$getConst('PHONE_INPUT_MASK')"
        placeholder="*Телефон"
      />
    </form>
    <demo-denied />
  </c-modal-form>
</template>

<script>
import CModalForm from '../../../../../../../resources/js/components/ui/CModalForm'
import CInput from '../../../../../../../resources/js/components/ui/CInput'
import form from '../../../../../../../resources/js/mixins/form'
import modal from '../../../../../../../resources/js/mixins/modal'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Notification from '../../../../../../../resources/js/notification'
import DemoDenied from '../DemoDenied'

/**
 * Модальное окно "Заказать услугу".
 */
export default {
  name: 'ServiceOrder',
  components: {
    DemoDenied,
    CModalForm,
    CInput
  },
  mixins: [form, modal],
  computed: {
    /**
     * Контактный телефон.
     */
    phone: {
      set (value) {
        this.setPhone(value)
      },
      get () {
        return this.$store.state.seo.forms.serviceOrder.phone
      }
    },
    /**
     * Происходит ли загрузка или отправка данных.
     *
     * @returns {boolean}
     */
    loading () {
      return !!(this.clientDomaisFetching || this.sending)
    },
    /**
     * Может ли форма быть отправлена.
     *
     * @returns {boolean}
     */
    canSubmit () {
      return !!(this.domainSelected && this.phone && this.service && !this.isDemo)
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      service: state => state.seo.forms.serviceOrder.service,
      clientDomaisFetching: state => state.seo.client.domains.fetching
    }),
    ...mapGetters({
      isDemo: 'seo/client/info/isDemo'
    })
  },
  methods: {
    /**
     * Отправляет данные формы.
     */
    submit () {
      this.sending = true
      this.error = false

      this.orderService({ domain: this.domainSelected, phone: this.phone, service: this.service })
        .then(() => {
          this.hideModal(this.$getConst('SERVICE_ORDER_MODAL_ID'))

          this.sending = false

          Notification.notifySuccess({
            title: 'Услуга заказана'
          })
        })
        .catch(() => {
          this.sending = false
          this.error = true
        })
    },
    ...mapMutations({
      setPhone: 'seo/forms/serviceOrder/setPhone'
    }),
    ...mapActions({
      orderService: 'seo/forms/serviceOrder/send'
    })
  }
}
</script>
